import EnumService from '../EnumService'

export default class SimNaoEnumService extends EnumService{

    constructor(){
        super('enumSimNao');
    }
  
  }